import CustomCheckBox from "components/CustomCheckBox";
import { cloneDeep } from "lodash";
import { useEffect, useState } from "react";

const initFilterData: any = {
    types: [],
    formats: [],
    durations: []
}

const initSelectState: any = {
    types: false,
    formats: false,
    durations: false
}

const fetesFormatData = [
    { title: 'In-Person', selected: false },
    { title: 'Hybrid', selected: false },
    { title: 'Online', selected: false },
]

const fetesDurationData = [
    { title: 'Single Day', selected: false },
    { title: 'Multi-Day', selected: false }
]

const FavFilters = ({ eventTypes, handleClick }: any) => {
    const [filterData, setFilterData] = useState<any>(initFilterData)
    const [mainSelection, setMainSelection] = useState<any>(initSelectState);
    const [renderFilter, setRenderFilter] = useState<boolean>(false)

    const handleFilter = () => {
        const stateData = cloneDeep(filterData)
        const types = (stateData.types.filter((el: any) => el.selected) || []).map((type: any) => type.title);
        const formats = (stateData.formats.filter((el: any) => el.selected) || []).map((format: any) => format.title);
        const durations = (stateData.durations.filter((el: any) => el.selected) || []).map((duration: any) => duration.title);

        const filterPayload = {
            types, formats, durations
        }

        handleClick(filterPayload)
        setRenderFilter(false)
    }

    useEffect(() => {
        fetchFilters()
    }, [])

    useEffect(() => {
        if (renderFilter) handleFilter();
    }, [renderFilter]);

    const fetchFilters = async () => {
        const typesData = eventTypes
        const formatsData = fetesFormatData;
        const durationsData = fetesDurationData;

        setFilterData({ ...filterData, types: typesData, formats: formatsData, durations: durationsData })
    }

    const handleTypeSelection = (payload: any) => {
        const { name, isChecked, varName } = payload
        setMainSelection({ ...mainSelection, [name]: isChecked });

        let selectedData = cloneDeep(filterData[varName]);
        selectedData = selectedData.map((sd: any) => ({ ...sd, selected: isChecked }))
        setFilterData({
            ...filterData,
            [varName]: selectedData
        })

        setRenderFilter(true)
    }

    const handleValueSelection = (payload: any) => {
        const { index, isChecked, varName } = payload
        let selectedData = cloneDeep(filterData[varName]);

        selectedData[index]['selected'] = isChecked;
        // Update state of Data
        setFilterData({
            ...filterData,
            [varName]: selectedData
        });

        // If atleast one item is unchecked, uncheck the main checkbox as well
        if (!isChecked) {
            setMainSelection({ ...mainSelection, [varName]: isChecked });
        }

        // If all items are checked, then check the main checkbox as well
        const isAllSelected = selectedData.every((sd: any) => sd.selected === true)
        if (isAllSelected) {
            setMainSelection({ ...mainSelection, [varName]: true });
        }

        setRenderFilter(true)
    }

    const clearAll = () => {
        setFilterData({
            types: filterData?.types?.map((el: any) => ({ ...el, selected: false })),
            formats: filterData?.formats?.map((el: any) => ({ ...el, selected: false })),
            durations: filterData?.durations.map((el: any) => ({ ...el, selected: false }))
        })
        setMainSelection({
            types: false, formats: false, durations: false
        })

        setRenderFilter(true)
    }

    return (
        <>
            {
                (filterData.types.length > 0 || filterData.formats.length > 0 || filterData.durations.length > 0) &&
                <div className="border border-[#D0D5DD] rounded-lg py-4 px-4 bg-[#fff] w-full max-w-[332px] flex-shrink-0">
                    {/* Heading */}
                    <div className="w-full flex items-center justify-between border-b border-[#EAECF0] pb-1">
                        <h3 className="text-lg text-[#101828] font-interBold pb-0.5">Filters</h3>
                        <span className="text-[#1E0AF5] font-interSemiBold text-sm cursor-pointer hover:bg-[#e8e6fe] px-1.5 py-0.5 rounded" onClick={clearAll}>
                            Clear All
                        </span>
                    </div>

                    {/* Filters */}
                    {<div className="">
                        <div className="">
                            <div className="mt-4 border-b border-[#F2F4F7]">
                                <CustomCheckBox
                                    name="types"
                                    label={'Types'}
                                    checked={mainSelection.types}
                                    customLabelStyle="font-interSemiBold text-base text-[#344054] pl-1.5 hover:text-[#1e0af5]"
                                    customStyle="mb-4"
                                    onChange={(name: string, isChecked: boolean) => handleTypeSelection({ name, isChecked, varName: 'types' })}
                                />

                                <div className="pl-6">
                                    {
                                        (filterData.types || []).map((item: any, index: number) => (
                                            <span className="checkbox-alignment mb-4 last:mb-3 flex" key={index}>
                                                <>
                                                    <CustomCheckBox
                                                        name={item.title}
                                                        label={item.title}
                                                        checked={item.selected}
                                                        customLabelStyle="font-interMedium text-sm text-[#344054] pl-1.5 hover:text-[#1e0af5]"
                                                        onChange={(name: string, isChecked: boolean) => handleValueSelection({ index, isChecked, varName: 'types' })}
                                                    />
                                                    <span className="font-interMedium text-sm text-[#344054] pl-1.5">
                                                        ({item?.count})
                                                    </span>
                                                </>

                                            </span>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="">
                            <div className="mt-4 border-b border-[#F2F4F7]">
                                <CustomCheckBox
                                    name="formats"
                                    label={'Formats'}
                                    checked={mainSelection.formats}
                                    customLabelStyle="font-interSemiBold text-base text-[#344054] pl-1.5 hover:text-[#1e0af5]"
                                    customStyle="mb-4"
                                    onChange={(name: string, isChecked: boolean) => handleTypeSelection({ name, isChecked, varName: 'formats' })}
                                />

                                <div className="pl-6">
                                    {
                                        (filterData.formats || []).map((item: any, index: number) => (
                                            <span className="checkbox-alignment mb-4 last:mb-3 block" key={index}>
                                                <CustomCheckBox
                                                    name={item.title}
                                                    label={item.title}
                                                    checked={item.selected}
                                                    customLabelStyle="font-interMedium text-sm text-[#344054] pl-1.5 hover:text-[#1e0af5]"
                                                    onChange={(name: string, isChecked: boolean) => handleValueSelection({ index, isChecked, varName: 'formats' })}
                                                />
                                            </span>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>

                        {/* durations */}
                        <div className="">
                            {
                                <div className="mt-5">
                                    <CustomCheckBox
                                        name="durations"
                                        label={'Durations'}
                                        checked={mainSelection.durations}
                                        customLabelStyle="font-interSemiBold text-base text-[#344054] pl-1.5 hover:text-[#1e0af5]"
                                        customStyle="mb-4"
                                        onChange={(name: string, isChecked: boolean) => handleTypeSelection({ name, isChecked, varName: 'durations' })}
                                    />
                                    <div className="pl-6">
                                        {
                                            (filterData.durations || []).map((item: any, index: number) => (
                                                <div className="checkbox-alignment mb-4 last:mb-0 block" key={index}>
                                                    <div className="flex items-center">
                                                        <CustomCheckBox
                                                            name={item.title}
                                                            label={item.title}
                                                            checked={item.selected}
                                                            customLabelStyle="font-interMedium text-sm text-[#344054] pl-1.5 hover:text-[#1e0af5]"
                                                            onChange={(name: string, isChecked: boolean) => handleValueSelection({ index, isChecked, varName: 'durations' })}
                                                        />
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>}
                </div>
            }
        </>
    )
}

export default FavFilters